import React from 'react';
import colours from '../utilities/colours.scss';
import LazyLoadModule from '../../helpers/LazyLoadModule';

export default ({ content }) => {
  const { icon = 'IosAlertOutline', title = '', message = '', colour = colours.red, cb = () => {} } = content;

  return (
    <div className="alertBackground">
      <div className="dashboardAlert">
        <LazyLoadModule resolve={() => import(`react-ionicons/lib/${icon}`)} style={{color: colour}} fontSize="75px" />
        <div className="alertTitle">{title}</div>
        <div className="alertMessage">{message}</div>
        <div className="themeButton alertButton" onClick={() => cb()}>OK</div>
      </div>
    </div>
  )
}
